function ExternalLink({
  href,
  children,
  ariaHide = false,
  bolded = true,
  underline = true,
}: {
  href: string;
  children: React.ReactNode;
  ariaHide?: boolean;
  bolded?: boolean;
  underline?: boolean;
}) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={`${bolded ? "font-bold" : ""} hover:text-text-hover transition-all duration-300 hover:scale-110 ${underline ? "underline underline-offset-4" : "no-underline"}`}
      aria-hidden={ariaHide ? "true" : undefined}
    >
      {children}
    </a>
  );
}

export default ExternalLink;
